import {CircleHelp, Mail} from 'lucide-react';
import React from 'react';

import {Alert, AlertTitle, AlertDescription} from '@/components/ui/alert';
import {Card, CardContent} from '@/components/ui/card';
import {WorkflowRunListObject} from "@/types/workflowRuns.js";
import NeedHelpAlert from "@/components/TaskHub/NeedHelpAlert.js";

type TaskRunningViewProps = {
  application: WorkflowRunListObject;
};

const delayedMessage = `We're working to complete your request as soon as possible.`;

const TaskRunningView = (props: TaskRunningViewProps) => {
  const {
    application
  } = props;

  const createdAt = new Date(application.workflow_run.created_at);
  const now = new Date();
  const hoursElapsed = Math.floor((now.getTime() - createdAt.getTime()) / (1000 * 60 * 60));
  const remainingHours = 24 - hoursElapsed;

  return (
    <div className='max-w-2xl mx-auto p-6'>
      <Card className='mb-8 bg-white'>
        <CardContent className='pt-6'>
          <div className='flex items-start justify-between mb-6'>
            <div>
              <h1 className='text-2xl font-semibold mb-1'>Application Submitted</h1>
              <p className={`${remainingHours < 0 ? 'text-red-600' : 'text-gray-600'}`}>
                {remainingHours < 0
                  ? delayedMessage
                  : `Your request will be processed within next ${remainingHours} hrs`
                }
              </p>
            </div>
            <span className='px-4 py-1 bg-blue-50 text-blue-700 rounded-md'>Processing</span>
          </div>

          <Alert className='mb-6'>
            <Mail className='h-4 w-4'/>
            <AlertTitle className='text-base font-semibold'>What happens next?</AlertTitle>
            <AlertDescription className='mt-2'>
              {`Kay will get to work and complete the application. If there are any additional questions, we will reach out to you via email.`}
            </AlertDescription>
          </Alert>

        </CardContent>
      </Card>

      <div className='mt-6'>
        <NeedHelpAlert />
      </div>

    </div>
  );
};

export default TaskRunningView;
